"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RailComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _request = require("@nicbase/request");

var _formik = require("formik");

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

var _constants = require("../constants");

var _informationStep = _interopRequireDefault(require("./information-step"));

var _loadingStep = _interopRequireDefault(require("./loading-step"));

var _monitoringStep = _interopRequireDefault(require("./monitoring-step"));

var _procedureStep = _interopRequireDefault(require("./procedure-step"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var createCoupledAsset = function createCoupledAsset(portalId, name, coupledAssets) {
  return {
    type: 'CREATE_COUPLED_ASSET_REQUEST',
    headers: {
      version: 'v3',
      portalId: portalId
    },
    body: {
      asset: {
        type: 240,
        name: name,
        coupledAssets: coupledAssets
      }
    }
  };
};

var updateCoupledAsset = function updateCoupledAsset(portalId, id, name, coupledAssets) {
  return {
    type: 'UPDATE_COUPLED_ASSET_REQUEST',
    headers: {
      version: 'v3',
      portalId: portalId
    },
    body: {
      asset: {
        type: 240,
        id: id,
        name: name,
        coupledAssets: coupledAssets
      }
    }
  };
};

var getCoupledAsset = function getCoupledAsset(portalId, id) {
  return {
    type: 'GET_COUPLED_ASSET_REQUEST',
    headers: {
      version: 'v3',
      portalId: portalId
    },
    body: {
      id: id
    }
  };
};

var getLoadingStepAssetSchema = function getLoadingStepAssetSchema(assetSelection) {
  switch (assetSelection) {
    case 'USE_EXISTING_ASSET':
      {
        return {
          id: (0, _yup.number)().required()
        };
      }

    case 'CREATE_NEW_ASSET':
      {
        return {
          name: (0, _yup.string)().required().min(1).max(64),
          coupledAssets: (0, _yup.array)((0, _yup.object)().shape({
            id: (0, _yup.number)().required()
          })).min(1)
        };
      }

    default:
      {
        return {};
      }
  }
};

var RailComponent = function RailComponent(_ref) {
  var _tour$dataRequest, _tour$additionalData, _tour$additionalData$, _tour$additionalData$2, _tour$additionalData2, _tour$additionalData3;

  var portalId = _ref.portalId,
      isActive = _ref.isActive,
      onSave = _ref.onSave,
      onUpdate = _ref.onUpdate,
      onCancel = _ref.onCancel,
      tour = _ref.tour,
      alarms = _ref.alarms;
  var isNewTour = tour.id === undefined;

  var _useState = (0, _react.useState)(!isNewTour && ((_tour$dataRequest = tour.dataRequest) === null || _tour$dataRequest === void 0 ? void 0 : _tour$dataRequest.type) === 'PORTAL' && !tour.assetId ? 'DATA_REQUEST' : 'USE_EXISTING_ASSET'),
      _useState2 = _slicedToArray(_useState, 2),
      assetSelection = _useState2[0],
      setAssetSelection = _useState2[1];

  var loadingStepSchema = (0, _yup.object)().shape({
    asset: (0, _yup.object)().shape(getLoadingStepAssetSchema(assetSelection)),
    dataRequest: (0, _yup.object)().shape({
      haulerPortalId: (0, _yup.number)().nullable()
    }).nullable()
  });
  var tourSchema = (0, _yup.object)().shape({
    name: (0, _yup.string)().min(1).max(64).required(),
    wayPoints: (0, _yup.array)().of((0, _yup.object)().shape({
      poiId: (0, _yup.number)().min(1).required(),
      frontendId: (0, _yup.string)().test({
        message: function message(msg) {
          return msg.value;
        },
        test: function test(value) {
          // if error with poi id then return the frontend id for the correct assignment in form
          if (this.parent.poiId) {
            return value;
          }

          return null;
        }
      })
    })),
    earliestStartTime: (0, _yup.date)().min(new Date()).nullable()
  });
  var schema = (0, _yup.object)().shape({
    tour: tourSchema,
    loadingStep: loadingStepSchema
  });
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentStep = _useState4[0],
      setCurrentStep = _useState4[1];

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var saveButtonLabel;
  var dialogTitle;

  if (isNewTour) {
    saveButtonLabel = 'widgets.tourBoard.createTour';
    dialogTitle = 'tourBoard.newTour.title';
  } else {
    saveButtonLabel = 'widgets.tourBoard.editTour';
    dialogTitle = 'tourBoard.editTour.title';
  }

  var _useFormik = (0, _formik.useFormik)({
    initialValues: {
      tour: tour,
      loadingStep: {
        asset: isNewTour ? {} : {
          id: tour.assetId,
          name: tour.assetName,
          type: tour.assetType,
          coupledAssets: (_tour$additionalData = tour.additionalData) === null || _tour$additionalData === void 0 ? void 0 : (_tour$additionalData$ = _tour$additionalData.railInfo) === null || _tour$additionalData$ === void 0 ? void 0 : (_tour$additionalData$2 = _tour$additionalData$.wagonLoadings) === null || _tour$additionalData$2 === void 0 ? void 0 : _tour$additionalData$2.map(function (wagonLoading) {
            return {
              id: wagonLoading.assetId,
              weight: wagonLoading.weight,
              nhmCode: wagonLoading.nhmCode,
              productDescription: wagonLoading.productDescription
            };
          })
        },
        dataRequest: isNewTour ? null : tour.dataRequest,
        dissolveTrainAfterTour: isNewTour ? false : Boolean((_tour$additionalData2 = tour.additionalData) === null || _tour$additionalData2 === void 0 ? void 0 : (_tour$additionalData3 = _tour$additionalData2.railInfo) === null || _tour$additionalData3 === void 0 ? void 0 : _tour$additionalData3.dissolveTrainAfterTour)
      }
    },
    validateOnMount: true,
    validationSchema: schema,
    onSubmit: function onSubmit() {
      if (isNewTour) {
        onSave(fields.tour);
      } else {
        onUpdate(fields.tour);
      }
    }
  }),
      handleSubmit = _useFormik.handleSubmit,
      fields = _useFormik.values,
      _useFormik$isValid = _useFormik.isValid,
      isValid = _useFormik$isValid === void 0 ? false : _useFormik$isValid,
      touched = _useFormik.touched,
      errors = _useFormik.errors,
      setFieldValue = _useFormik.setFieldValue,
      setFieldTouched = _useFormik.setFieldTouched;

  var _useMutation = (0, _reactQuery.useMutation)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, _asset, _yield$request2, asset;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isNewTour) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return request(createCoupledAsset(portalId, fields.loadingStep.asset.name, fields.loadingStep.asset.coupledAssets));

          case 3:
            _yield$request = _context.sent;
            _asset = _yield$request.body.asset;
            return _context.abrupt("return", _asset.id);

          case 6:
            _context.next = 8;
            return request(updateCoupledAsset(portalId, fields.loadingStep.asset.id, fields.loadingStep.asset.name, fields.loadingStep.asset.coupledAssets));

          case 8:
            _yield$request2 = _context.sent;
            asset = _yield$request2.body.asset;
            return _context.abrupt("return", asset.id);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))),
      createNewTrain = _useMutation.mutateAsync;

  var saveLoadingStep = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var _fields$loadingStep$a, isTrainLoaded, wagonLoadings;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(assetSelection === 'DATA_REQUEST')) {
              _context2.next = 10;
              break;
            }

            setFieldValue('tour.dataRequest', fields.loadingStep.dataRequest);
            setFieldValue('tour.assetId', null);
            setFieldValue('tour.assetName', null);
            setFieldValue('tour.assetType', null);
            setFieldValue('tour.additionalData.railInfo.dissolveTrainAfterTour', false);
            setFieldValue('tour.additionalData.railInfo.wagonLoadings', null);
            setFieldValue('tour.loaded', false);
            _context2.next = 26;
            break;

          case 10:
            setFieldValue('tour.dataRequest', null);
            _context2.t0 = setFieldValue;

            if (!(assetSelection === 'USE_EXISTING_ASSET')) {
              _context2.next = 16;
              break;
            }

            _context2.t1 = fields.loadingStep.asset.id;
            _context2.next = 19;
            break;

          case 16:
            _context2.next = 18;
            return createNewTrain();

          case 18:
            _context2.t1 = _context2.sent;

          case 19:
            _context2.t2 = _context2.t1;
            (0, _context2.t0)('tour.assetId', _context2.t2);
            setFieldValue('tour.assetName', fields.loadingStep.asset.name);
            setFieldValue('tour.assetType', fields.loadingStep.asset.type);
            setFieldValue('tour.additionalData.railInfo.dissolveTrainAfterTour', fields.loadingStep.dissolveTrainAfterTour);
            isTrainLoaded = ((_fields$loadingStep$a = fields.loadingStep.asset.coupledAssets) === null || _fields$loadingStep$a === void 0 ? void 0 : _fields$loadingStep$a.filter(function (coupledAsset) {
              return Object.keys(coupledAsset).some(function (key) {
                return key === 'nhmCode' || key === 'weight' || key === 'productDescription';
              });
            }).length) > 0;

            if (isTrainLoaded) {
              wagonLoadings = fields.loadingStep.asset.coupledAssets.map(function (coupledAsset) {
                return {
                  assetId: coupledAsset.id,
                  weight: coupledAsset.weight,
                  nhmCode: coupledAsset.nhmCode,
                  productDescription: coupledAsset.productDescription
                };
              });
              setFieldValue('tour.additionalData.railInfo.wagonLoadings', wagonLoadings);
              setFieldValue('tour.loaded', true);
            }

          case 26:
            // save tour
            handleSubmit();

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [assetSelection, createNewTrain, fields.loadingStep.asset.coupledAssets, fields.loadingStep.asset.id, fields.loadingStep.asset.name, fields.loadingStep.asset.type, fields.loadingStep.dataRequest, fields.loadingStep.dissolveTrainAfterTour, handleSubmit, setFieldValue]);

  var _useQuery = (0, _reactQuery.useQuery)(['portal', portalId, 'coupledAssets', fields.loadingStep.asset.id], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var _yield$request3, asset;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return request(getCoupledAsset(portalId, fields.loadingStep.asset.id));

          case 2:
            _yield$request3 = _context3.sent;
            asset = _yield$request3.body.asset;
            return _context3.abrupt("return", asset);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), {
    enabled: Boolean(assetSelection === 'USE_EXISTING_ASSET' && fields.loadingStep.asset && (0, _mapping.isCoupledAsset)(fields.loadingStep.asset.type)),
    onSuccess: function onSuccess(response) {
      var _tour$additionalData4, _tour$additionalData5, _response$coupledAsse;

      // sort coupled assets by same order as wagon loadings
      var existingWagonLoadings = tour === null || tour === void 0 ? void 0 : (_tour$additionalData4 = tour.additionalData) === null || _tour$additionalData4 === void 0 ? void 0 : (_tour$additionalData5 = _tour$additionalData4.railInfo) === null || _tour$additionalData5 === void 0 ? void 0 : _tour$additionalData5.wagonLoadings;

      if (existingWagonLoadings) {
        var sortArray = existingWagonLoadings.map(function (wagon) {
          return wagon.assetId;
        });
        response.coupledAssets.sort(function (a, b) {
          return sortArray.indexOf(a.id) - sortArray.indexOf(b.id);
        });
      }

      setFieldValue('loadingStep.asset.coupledAssets', response === null || response === void 0 ? void 0 : (_response$coupledAsse = response.coupledAssets) === null || _response$coupledAsse === void 0 ? void 0 : _response$coupledAsse.map(function (coupledAsset) {
        var _tour$additionalData6, _tour$additionalData7, _tour$additionalData8;

        var existingWagonLoading = tour === null || tour === void 0 ? void 0 : (_tour$additionalData6 = tour.additionalData) === null || _tour$additionalData6 === void 0 ? void 0 : (_tour$additionalData7 = _tour$additionalData6.railInfo) === null || _tour$additionalData7 === void 0 ? void 0 : (_tour$additionalData8 = _tour$additionalData7.wagonLoadings) === null || _tour$additionalData8 === void 0 ? void 0 : _tour$additionalData8.find(function (wagonLoading) {
          return wagonLoading.assetId === coupledAsset.id;
        });

        if (existingWagonLoading) {
          return _objectSpread(_objectSpread({}, coupledAsset), {}, {
            weight: existingWagonLoading.weight,
            nhmCode: existingWagonLoading.nhmCode,
            productDescription: existingWagonLoading.productDescription
          });
        }

        return coupledAsset;
      }));
    }
  }),
      isLoadingCoupledAsset = _useQuery.isLoading;

  var onTourMerge = (0, _react.useCallback)(function (values) {
    var _Object$entries = Object.entries(values),
        _Object$entries2 = _slicedToArray(_Object$entries, 1),
        _Object$entries2$ = _slicedToArray(_Object$entries2[0], 2),
        key = _Object$entries2$[0],
        value = _Object$entries2$[1];

    setFieldTouched("tour.".concat(key));
    setFieldValue("tour.".concat(key), value);
  }, [setFieldTouched, setFieldValue]);
  var tourIsValid = tour.status !== _constants.TOUR_STATUS.RUNNING && tour.status !== _constants.TOUR_STATUS.FINISHED && isValid;
  var steps = (0, _react.useMemo)(function () {
    var _errors$tour, _errors$tour2, _errors$tour3;

    return [{
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-full h-full flex flex-col items-center p-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_informationStep["default"], {
        tour: fields.tour,
        onUpdate: onTourMerge,
        errors: errors.tour,
        touched: touched.tour
      })),
      title: intl.formatMessage({
        id: 'widgets.tourBoard.rail.createTour.information'
      }),
      inputsAreValid: !((_errors$tour = errors.tour) !== null && _errors$tour !== void 0 && _errors$tour.name),
      saveButtonAction: function saveButtonAction() {
        return setCurrentStep(function (prevStep) {
          return prevStep + 1;
        });
      },
      saveButtonLabelId: 'common.nextStep'
    }, {
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-full h-full flex flex-col justify-center items-center p-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_procedureStep["default"], {
        tour: fields.tour,
        onUpdate: onTourMerge,
        errors: errors.tour,
        touched: touched.tour
      })),
      title: intl.formatMessage({
        id: 'widgets.tourBoard.rail.createTour.procedure'
      }),
      inputsAreValid: !((_errors$tour2 = errors.tour) !== null && _errors$tour2 !== void 0 && _errors$tour2.wayPoints) && !((_errors$tour3 = errors.tour) !== null && _errors$tour3 !== void 0 && _errors$tour3.earliestStartTime),
      saveButtonAction: function saveButtonAction() {
        return setCurrentStep(function (prevStep) {
          return prevStep + 1;
        });
      },
      saveButtonLabelId: 'common.nextStep'
    }, {
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-full h-full flex flex-col justify-center items-center p-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_loadingStep["default"], {
        formData: fields.loadingStep,
        setFieldValue: setFieldValue,
        setFieldTouched: setFieldTouched,
        isNewTour: isNewTour,
        assetSelection: assetSelection,
        setAssetSelection: setAssetSelection,
        isLoadingCoupledAsset: isLoadingCoupledAsset,
        touched: touched.loadingStep,
        errors: errors.loadingStep
      })),
      title: intl.formatMessage({
        id: 'widgets.tourBoard.rail.createTour.loading'
      }),
      inputsAreValid: !errors.loadingStep,
      saveButtonAction: function saveButtonAction() {
        return setCurrentStep(function (prevStep) {
          return prevStep + 1;
        });
      },
      saveButtonLabelId: 'common.nextStep'
    }, {
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-full h-full flex flex-col items-center p-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_monitoringStep["default"], {
        tour: fields.tour,
        onUpdate: onTourMerge,
        alarms: alarms
      })),
      title: intl.formatMessage({
        id: 'widgets.tourBoard.rail.createTour.monitoring'
      }),
      inputsAreValid: tourIsValid,
      saveButtonAction: function () {
        var _saveButtonAction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  saveLoadingStep();

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function saveButtonAction() {
          return _saveButtonAction.apply(this, arguments);
        }

        return saveButtonAction;
      }(),
      saveButtonLabelId: saveButtonLabel
    }];
  }, [alarms, assetSelection, errors.loadingStep, errors.tour, fields.loadingStep, fields.tour, intl, isLoadingCoupledAsset, isNewTour, onTourMerge, saveButtonLabel, saveLoadingStep, setFieldTouched, setFieldValue, touched.loadingStep, touched.tour, tourIsValid]);

  var isNextStepButtonDisabled = function isNextStepButtonDisabled() {
    if (currentStep === 0) {
      var _errors$tour4;

      return Boolean((_errors$tour4 = errors.tour) === null || _errors$tour4 === void 0 ? void 0 : _errors$tour4.name);
    }

    if (currentStep === 1) {
      var _errors$tour5, _errors$tour6;

      return Boolean(((_errors$tour5 = errors.tour) === null || _errors$tour5 === void 0 ? void 0 : _errors$tour5.wayPoints) && !!((_errors$tour6 = errors.tour) !== null && _errors$tour6 !== void 0 && _errors$tour6.earliestStartTime));
    }

    if (currentStep === 2) {
      return Boolean(errors === null || errors === void 0 ? void 0 : errors.loadingStep);
    }

    if (currentStep === steps.length - 1) {
      return !tourIsValid;
    }

    return false;
  };

  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.BasisDialog, {
    className: _indexModule["default"].createTourDialog,
    active: isActive,
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: dialogTitle
    }),
    content: /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Steps, {
      className: _indexModule["default"].createTourContent,
      barClassName: "min-w-64",
      currentStep: currentStep,
      onCurrentStepChange: setCurrentStep,
      steps: steps
    }),
    actions: [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      key: "rail-tour-dialog-button-cancel",
      primary: true,
      onClick: onCancel,
      className: "mr-3"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.cancel"
    })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      key: "rail-tour-dialog-button-save",
      primary: true,
      raised: true,
      onClick: steps[currentStep].saveButtonAction,
      disabled: isNextStepButtonDisabled()
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: steps[currentStep].saveButtonLabelId
    }))]
  });
};

exports.RailComponent = RailComponent;

var noop = function noop() {};

RailComponent.propTypes = {
  portalId: _propTypes["default"].number.isRequired,
  isActive: _propTypes["default"].bool.isRequired,
  onSave: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  tour: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    assetId: _propTypes["default"].number,
    assetName: _propTypes["default"].string,
    assetType: _propTypes["default"].number,
    dataRequest: _propTypes["default"].shape({
      type: _propTypes["default"].string,
      haulerPortalId: _propTypes["default"].number
    }),
    additionalData: _propTypes["default"].shape({
      railInfo: _propTypes["default"].shape({
        dissolveTrainAfterTour: _propTypes["default"].bool,
        wagonLoadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
          assetId: _propTypes["default"].number
        }))
      })
    }),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    status: _propTypes["default"].string
  }),
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape())
};
RailComponent.defaultProps = {
  tour: {
    alarms: []
  },
  alarms: [],
  onSave: noop,
  onUpdate: noop,
  onCancel: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(RailComponent);

exports["default"] = _default;